/**
 * @typedef {Object} AnchorConfig
 * @property {string} [href]
 * @property {(event: MouseEvent) => void} [onClick]
 * @property {"_blank"} [target]
 * 
 * @param {AnchorConfig} cfg 
 * @param {...(HTMLElement|string)} children
 */
function anchor(cfg, ...children) {
    const anchor = document.createElement("a")
    anchor.append(...children)
    if (cfg.href) anchor.href = cfg.href
    if (cfg.onClick) anchor.onclick = cfg.onClick
    if (cfg.target) anchor.target = cfg.target
    return anchor
}

/**
 * @param {HTMLAnchorElement|string} child 
 * @returns {HTMLLIElement}
 */
function listItem(child) {
    const li = document.createElement("li")
    li.append(child)
    return li
}

/**
 * @param {string} text 
 */
function paragraph(text) {
    const p = document.createElement("p")
    p.append(text)
    return p
}

/**
 * @param  {...(HTMLAnchorElement|string)} children
 */
function unorderedList(...children) {
    const ul = document.createElement("ul")
    ul.replaceChildren(...children.map(c => listItem(c)))

    /**
     * @param {string} text 
     */
    function append(text) {
        ul.appendChild(listItem(text))
    }

    return {
        append: append,
        element: ul,
    }
}

export const Html = {
    anchor,
    paragraph,
    unorderedList,
}
